export function queryRequired<T extends Element = HTMLElement>(
  root: ParentNode,
  selector: string,
): T {
  const element = root.querySelector<T>(selector);
  if (!element) throw new Error(`PUBLIC_RUNTIME_MISSING_ELEMENT:${selector}`);
  return element;
}

export function queryOptional<T extends Element = HTMLElement>(
  root: ParentNode,
  selector: string,
): T | null {
  return root.querySelector<T>(selector);
}

export function readJsonScript<T = unknown>(id: string, doc: Document = document): T | null {
  const element = doc.getElementById(id);
  if (!element) return null;
  const raw = readConfigElementText(element);
  if (!raw.trim()) return null;
  try {
    return JSON.parse(raw) as T;
  } catch (error) {
    throw new Error(`PUBLIC_RUNTIME_INVALID_JSON:${id}:${(error as Error).message}`);
  }
}

function readConfigElementText(element: HTMLElement): string {
  if (element instanceof HTMLTemplateElement) {
    return element.content.textContent || '';
  }
  return element.textContent || '';
}

export function findRuntimeRoot(selector: string, doc: Document = document): HTMLElement | null {
  return doc.querySelector<HTMLElement>(selector);
}
